import{withStyles as o}from"@material-ui/core/styles";var r="#ECF0F3",l=o({"@global":{body:{backgroundColor:r}}})((function(){return null}));export{r as SettingsThemeBackgroundColor,l as SettingsThemeOverride};
